export default class Constants {
  static MOBILE_SCREEN_WIDTH: number = 768;
}
